import React from "react";
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import HistoryIcon          from '@mui/icons-material/History';


const ADIM_menus = [
    {
        label: 'sidebar.menu.adim',
        type: "section",
        children: [
            {
                uri: "/adim/process-matter",
                label: 'sidebar.menuItem.process_matter',
                type: "nav-item",
                icon: <ListAltOutlinedIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/adim/track-task",
                label: 'sidebar.menuItem.track_task',
                type: "nav-item",
                icon: <HistoryIcon sx={{fontSize: 20}}/>
            },
            
        ]
    },
   
];

export default ADIM_menus;
